import type { ContactStage } from '@/api/entity_types/Contact';
import type { LicenseStatusLabel } from '@/types/LicenseStatusLabel';

export type SortOption = (typeof sortOptions)[number];
export const sortOptions = ['order_index', 'name', 'applied', 'license_status', 'stage', 'created'] as const;

export type DisplayOption = (typeof displayOptions)[number];
export const displayOptions = ['kanban', 'list'] as const;

export type OrderOption = (typeof orderOptions)[number];
export const orderOptions = ['asc', 'desc'] as const;

export type CandidateEntity = {
  order_index: number;
  column_id: number;
  stage: number | string;
  id: number;
  initials: string;
  name: string;
  first_name: string;
  last_name: string;
  applied_at: string;
  application_count: number;
  license_status: LicenseStatusLabel;
  phone: string;
  email: string;
  tags?: string[];
  lead_source?: string;
  rownum: number;
  can_receive_sms: boolean;
  stage_name: ContactStage;
  is_referred?: boolean;
  referred_by_name?: string | null;
  referred_by_contact_id?: number | null;
};
